

import { Box, Checkbox, FormControlLabel } from '@mui/material'; // ⬅️ add Checkbox
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import BaseCard from '../../../components/Cards/Card';
import CustomEmailInput from '../../../components/EmailInput';
import CustomPasswordInput from "../../../components/PasswordInput";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useFormik } from 'formik';
import { toast, Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import {BASE_URL,URL} from "../../../components/BaseUrl";
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { setCredentials } from '../../../Redux/Slices/AuthSlice';
import VerificationModal from './VerificationModal';
import PasswordNotSetModal from './PasswordNotSetModal';
import ProfileIncompleteModal from "./ProfileIncompleteModal";

const Login = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
const navigate=useNavigate()
const { t } = useTranslation();
const dispatch = useDispatch();
const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);


const [passwordNotSetModal, setPasswordNotSetModal] = useState({
  open: false,
  email: "",
  message: "",
});
const [profileIncompleteModal, setProfileIncompleteModal] = useState({
  open: false,
  profileUpdateToken: "",
});
    useEffect(() => {
    const saved = localStorage.getItem("credentials");
    if (saved) {
      const { email, password } = JSON.parse(saved);
      formik.setFieldValue("email", email);
      formik.setFieldValue("password", password);
      setRememberMe(true);
    }
  }, []);



  const [verificationModal, setVerificationModal] = useState({
    open: false,
    message: "",
    email: ""
  })
const validate = (values) => {
  const errors = {};

  // Email validation
  if (!values.email) {
    errors.email = t('login.emailRequired');
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
    errors.email = t('login.emailInvalid');
  }

  // Password validation
  if (!values.password) {
    errors.password = t('login.passwordRequired');
  }
  return errors; 
}; 
  const formik = useFormik({
    initialValues: { email: '', password: '' },
    validate,
    onSubmit: async (values) => {
      const errors = validate(values);
      if (Object.keys(errors).length > 0) {
        // Show first error
        if (errors.email) toast.error(errors.email);
        else if (errors.password) toast.error(errors.password);
        return;
      }

  setLoading(true); // Start loader
  try {
    const response = await fetch(`${BASE_URL}/account-executive/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    });

    const data = await response.json();

    console.log("response of login is", data)

           if (data?.data?.requiresProfileCompletion) {
  if (data.data.profileUpdateToken) {
    localStorage.setItem("profileUpdateToken", data.data.profileUpdateToken);
  }
  setProfileIncompleteModal({
    open: true,
    profileUpdateToken: data.data.profileUpdateToken,
  });
  return; // ⛔ stop normal login flow
}


    if (data?.data?.requiresApproval) {
  // navigate directly to AdminApproval screen
  navigate("/admin-approval", { state: { message: data.message } });
  return;
}


    if (data?.data?.requiresPasswordSetup) {
  setPasswordNotSetModal({
    open: true,
    email: data.data.email,
    message: data.message || data.data.suggestion,
  });
  return; // ⛔ stop normal login flow
}

          if (data?.data?.requiresVerification) {
          // 🔴 Show modal instead of navigating
          setVerificationModal({
            open: true,
            message: data.message,
            email: data.data.email
          });
          return;
        }

 
    if (!response.ok || data.error) {
      throw new Error(data.message || "Login failed");
    }
    console.log("Original token:", data.data.token);
         if (rememberMe) {
        localStorage.setItem("credentials", JSON.stringify(values));
      } else {
        localStorage.removeItem("credentials");
      }
dispatch(setCredentials({ token: data.data.token, user: data.data.user }));
    setTimeout(() => {
      navigate("/dashboard");
    }, 1500);
  } catch (error) {
    toast.error(error.message || "login.loginFailed");
  } finally {
    setLoading(false); // Stop loader
  }
}
  });
const handleForget=()=>{
    navigate("/forget-password")
}
const [verifyLoading, setVerifyLoading] = useState(false);
const handleContinueVerification = async () => {
  setVerifyLoading(true); // show loader
  try {
    const response = await fetch(`${BASE_URL}/account-executive/resend-verification-otp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: verificationModal.email }),
    });
    const data = await response.json();
    console.log("Resend verification response:", data);
    if (!response.ok || data.error) {
      throw new Error(data.message || "Failed to resend verification");
    }
    toast.success(data.message);
 setTimeout(() => {
  setVerificationModal({ ...verificationModal, open: false });
  const userId = data.data.userId;  
  const token = data.data.otp;   
  navigate(
  `/otp-screen`
);

}, 1000);

  } catch (err) {
    toast.error(err.message || t("Something went wrong"));
  } finally {
    setVerifyLoading(false); // stop loader
  }
};


const handleProfileContinue = () => {
  navigate("/create-profile", {
    state: {
      profileUpdateToken: profileIncompleteModal.profileUpdateToken,
    },
  });
};
  return (
    <Box sx={{ backgroundColor: "#EFF4F8", mt:isMobile?6: 0, pt: 0,py:5,  }}>

      <Box sx={{ px: 2, display: 'flex', justifyContent: 'center',
         minHeight: "100vh",
          alignItems: "center",
       }}>
        <BaseCard
          maxWidth={isMobile ? '100%' : 380}
          sx={{
            width: isMobile ? '100%' : 'auto',
            boxSizing: 'border-box',
            px: isMobile ? 2 : 0,
          }}
        >
          <form onSubmit={formik.handleSubmit}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.8 ,mb:2}}>
              <CustomText sx={{ ...textStyles.h4, color: theme.palette.tertiary.main,letterSpacing:"0px !important" }}>
        {t('login.title')}
              </CustomText>
              <CustomText sx={{ ...textStyles.body4, color: theme.palette.text.primary,letterSpacing:"0px !important"  }}>
          {t('login.subtitle')}
              </CustomText>
              </Box>

              <label className='email_label'>{t('login.emailLabel')}</label>
              <CustomEmailInput
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && formik.errors.email}
              />
              {formik.touched.email && formik.errors.email && (
                <span style={{ color: 'red', fontSize: '12px' }}>{formik.errors.email}</span>
              )}

              <label>{t('login.passwordLabel')}</label>
              <CustomPasswordInput
              placeholder='********'
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.password && formik.errors.password}
              />
              {formik.touched.password && formik.errors.password && (
                <span style={{ color: 'red', fontSize: '12px' }}>{formik.errors.password}</span>
              )}
  

              {/* <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <CustomText sx={{ ...textStyles.body4,fontWeight:400, color: theme.palette.primary.main ,cursor:"pointer",letterSpacing:"0px !important"}} onClick={handleForget}>
               {t('login.forgotPassword')}
                </CustomText>
              </Box> */}
                 <Box sx={{ display: "flex",
                  flexWrap:"wrap", justifyContent: "space-between", alignItems: "center", mt: 1 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                      size="small"
                      sx={{ p: 0, mr: 1 }} // remove extra padding, keep small gap
                    />
                  }
                  label={
                    <CustomText sx={{ ...textStyles.body4, fontWeight: 400, color: theme.palette.text.primary }}>
                      {t("login.rememberMe")}
                    </CustomText>
                  }
                />
                <CustomText
                  sx={{
                    ...textStyles.body4,
                    fontWeight: 400,
                    color: theme.palette.primary.main,
                    cursor: "pointer",
                    ml: 1,
                    letterSpacing: "0px !important"
                  }}
                  onClick={handleForget}
                >
                  {t("login.forgotPassword")}
                </CustomText>
              </Box>

              <CustomButton
  label={
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
     
      {loading && (
        <CircularProgress
          size={18}
          sx={{ color: '#fff', mr: 1 }}
        />
      )}
       {t('login.loginButton')}
    </Box>
  }
  type="submit"
  fullWidth
  sx={{ mt: 2 }}
/>
            </Box>
          </form>
        </BaseCard>
      </Box>
          <VerificationModal
        open={verificationModal.open}
        message={verificationModal.message}
        onClose={() => setVerificationModal({ ...verificationModal, open: false })}
        onContinue={handleContinueVerification}
          loading={verifyLoading} 
      />
      <PasswordNotSetModal
  open={passwordNotSetModal.open}
  onClose={() => setPasswordNotSetModal({ ...passwordNotSetModal, open: false })}
  email={passwordNotSetModal.email}
  message={passwordNotSetModal.message}
/>

<ProfileIncompleteModal
  open={profileIncompleteModal.open}
  onClose={() =>
    setProfileIncompleteModal({ open: false, profileUpdateToken: "" })
  }
  onContinue={handleProfileContinue}
/>
    </Box>
  );
};

export default Login;








